import React from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  Button,
  Grid,
  Checkbox,
  TextField,
  Typography,
  Box,
  IconButton,
} from "@mui/material";
import { DataGrid } from "@mui/x-data-grid";
import CloseIcon from "@mui/icons-material/Close";

const GCRegisterSerialNumberModal = ({
  open,
  handleClose,
  autoSave,
  setAutoSave,
  serialNumber,
  setSerialNumber,
  selectedSerialNumbers,
  selectedRowIds, // For multi-select delete
  setSelectedRowIds, // Setter for selected row IDs
  handleSerialChange,
  handleAutoSaveToggle,
  handleSave,
  handleDelete,
  Document = [],
  DocumentColumn = [],
  SrNoColumn = [],
  xDisable
}) => {
  return (
    <Dialog open={open} onClose={handleClose} maxWidth="lg" fullWidth>
      <DialogTitle>
        Register Serial Number
        <IconButton
          aria-label="close"
          onClick={handleClose}
          sx={{
            position: "absolute",
            right: 8,
            top: 8,
            color: (theme) => theme.palette.grey[500],
          }}
        >
          <CloseIcon />
        </IconButton>
      </DialogTitle>
      <DialogContent>
        <Typography variant="h6">Rows from Document</Typography>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <DataGrid
              rowHeight={30}
              headerHeight={40}
              rows={Document}
              columns={DocumentColumn}
              pageSize={1}
              disableSelectionOnClick
              hideFooter={Document.length < 100}
              sx={{ height: 90 }}
            />
          </Grid>
        </Grid>

        <DialogActions>
          <Typography>
            Total Qty{" "}
            {Document.reduce((sum, item) => sum + item.B_Qty, 0)}
          </Typography>
        </DialogActions>
        <Grid container spacing={2} style={{ marginTop: 20 }}>
          <Grid item xs={12} sm={6}>
            <Box display="flex" alignItems="center">
              <Checkbox checked={autoSave} onChange={handleAutoSaveToggle} />
              <Typography>Auto Save (Not Recommended)</Typography>
            </Box>
          </Grid>
          <Grid item xs={12} sm={6}>
            <TextField
              label="Serial Number"
              variant="outlined"
              fullWidth
              value={serialNumber}
              onChange={handleSerialChange}
            />
          </Grid>
        </Grid>

        <Typography variant="h6" style={{ marginTop: 20 }}>
          Selected Serial Numbers
        </Typography>
        <DataGrid
          rows={selectedSerialNumbers}
          columns={SrNoColumn}
          rowHeight={30}
          headerHeight={40}
          checkboxSelection // Enable multi-select for delete
          selectionModel={selectedRowIds} // Multi-select model
          onSelectionModelChange={(newSelection) => {
            setSelectedRowIds(newSelection); // Update selected row IDs for deletion
          }}
          sx={{ height: 300 }}
          hideFooter={selectedSerialNumbers.length < 100}
        />
      </DialogContent>

      <DialogActions>
        <Button
          onClick={handleSave}
          variant="contained"
          color="primary"
          disabled={serialNumber === "" ||xDisable} // Disable save if no serial number is entered
        >
          Save
        </Button>
        <Button
          onClick={handleDelete}
          variant="contained"
          color="secondary"
          disabled={selectedRowIds.length === 0 || xDisable} // Disable delete if no rows selected
        >
          Delete
        </Button>
        <Typography>
          Total Qty{" "}
          {selectedSerialNumbers.reduce((sum, item) => sum + item.Qty, 0)}
        </Typography>
      </DialogActions>
    </Dialog>
  );
};

export default GCRegisterSerialNumberModal;
